import { selectColourStyles, selectTheme } from "@components/common/common";
import { useState } from "react";

import Select from "react-select";
import clsx from "clsx";
import makeAnimated from "react-select/animated";
import style from "@scss/modals/company/create-company.module.scss";
import useModal from "@modals/modal-hook";
import useStyles from "@ui/material-ui-styles";

const animatedComponents = makeAnimated();

const RemoveRoleWithUsersModal: React.FC = () => {
  const [selectedRole, setSelectedRole] = useState<number>();
  const { close, modalComponent, modalData } = useModal();
  const classes = useStyles();

  const handleSubmit = (e: any) => {
    e.preventDefault();
    modalData.onConfirm(modalData.id, selectedRole);
    close();
  };

  return (
    <div key={modalComponent.key} className={clsx(style.create_company_modal)}>
      <p className="modal_title">
        {modalData.text}
        <br />
        <span style={{ fontSize: "14px", fontWeight: "400" }}>
          {modalData.textUsers}
        </span>
      </p>
      <p className="modal_title" style={{ paddingBottom: 0 }}>
        Выберите роль для замены
      </p>
      <form className={`modal_content ${classes.root}`} onSubmit={handleSubmit}>
        <Select
          closeMenuOnSelect={true}
          components={animatedComponents}
          options={modalData.roles.map((e: { id: any; name: any }) => ({
            value: e.id,
            label: e.name,
          }))}
          isSearchable
          menuPortalTarget={document.body}
          placeholder={"Роли"}
          onChange={(values: any) => setSelectedRole(+values.value)}
          styles={selectColourStyles()}
          theme={selectTheme}
        />
        <button type="submit" className="modal_btn">
          {modalComponent.btnText}
        </button>
      </form>
    </div>
  );
};

export default RemoveRoleWithUsersModal;
